import {
	Button,
	FormControl,
	InputText,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Modalv2
} from "@itandi/itandi-bb-ui";
import type React from "react";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { useSWRConfig } from "swr";
import { useDealContext } from "~/context/DealContext";
import { dealCacheKey } from "~/hooks/useDeals";
import { getOriginVendor } from "~/models/DealVendorCompany";
import { ItandiAccountContext } from "~/models/ItandiAccount";
import { canOperatingDeal } from "~/models/Staff";
import { isSuccess } from "~/utils/api/api_handler";
import { create as postCancel } from "~/utils/api/deals/DealCancel";

export const DealCancelButtonClient: React.FC = () => {
	const deal = useDealContext();
	const account = useContext(ItandiAccountContext);
	const { mutate: globalMutate } = useSWRConfig();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [reason, setReason] = useState<string>("");
	const assignedVendor = getOriginVendor(deal);

	const handleAccept = async (): Promise<void> => {
		setIsSubmitting(true);
		const result = await postCancel(deal.id, reason);
		if (isSuccess(result)) {
			await globalMutate(dealCacheKey(deal.id));
			toast.success("案件を取り下げました");
			setIsModalOpen(false);
		} else {
			toast.error(result.message ?? "エラーが発生しました。");
		}
		setIsSubmitting(false);
	};

	return (
		<>
			<Button
				disabled={!canOperatingDeal(account)}
				ml="auto"
				onClick={() => {
					setIsModalOpen(true);
				}}
				variant="danger"
			>
				案件の取り下げ
			</Button>
			{isModalOpen ? (
				<Modalv2
					isOpen
					onClose={() => {
						setIsModalOpen(false);
					}}
				>
					<ModalHeader title="案件の取り下げ" />
					<ModalBody>
						<FormControl
							label={`取り下げ理由${
								assignedVendor ? "（施工会社に通知されます）" : ""
							}`}
							variant="vertical"
						>
							<InputText
								maxRows={8}
								onChange={(e) => {
									setReason(e.target.value);
								}}
								resize="autoRows"
								rows={4}
								value={reason}
							/>
						</FormControl>
					</ModalBody>
					<ModalFooter
						leftArea={
							<Button
								disabled={isSubmitting}
								onClick={() => {
									setIsModalOpen(false);
								}}
								variant="secondary"
							>
								キャンセル
							</Button>
						}
						rightArea={
							<Button
								disabled={!!assignedVendor && reason === ""}
								loading={isSubmitting}
								onClick={handleAccept}
								variant="primary"
							>
								案件を取り下げる
							</Button>
						}
					/>
				</Modalv2>
			) : null}
		</>
	);
};
